import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

interface InfoBubbleHeroHeaderProps {}

/*
 * Style.
 */

const StyledDiv = styled.div`
  overflow: hidden;
`;

/*
 * Component.
 */

export const InfoBubbleHeroHeader: FC<PropsWithChildren<InfoBubbleHeroHeaderProps>> = ({children}) => (
  <StyledDiv>{children}</StyledDiv>
);
